import React, { FC, useMemo, useRef, useState } from 'react';

import { Button } from 'devextreme-react/button';
import DataGrid, {
  Column,
  FilterPanel,
  FilterRow,
  HeaderFilter,
  Lookup,
  Pager,
  Paging,
  StateStoring,
} from 'devextreme-react/data-grid';
import 'devextreme-react/text-area';

import { AppCard, AppLayoutTop } from '../../../../components/appComponents';
import ClaimsProvider from '../../../../components/claimsBlock';
import $createDataSource from '../../../../utils/create-data-souce-instance';
import $createStore from '../../../../utils/create-store-instance';
import DeleteModal from './modals/delete';
import AddEditModal from './modals/edit-add';

const TransportPage: FC = () => {
  const [visible, setVisible] = useState<boolean>(false);
  const [openId, setOpenId] = useState<number | null>(null);

  const [visibleDelete, setVisibleDelete] = useState<boolean>(false);
  const [openIdDelete, setOpenIdDelete] = useState<number | null>(null);

  const transportDataStore: any = useMemo(() => {
    return $createDataSource('/v1/transport', 'id', { defaultFilter: ['id', '>', '0'] });
  }, []);

  const typeTransport: any = useMemo(() => {
    return $createStore('/v1/Transport/types', 'id');
  }, []);

  const refGrid = useRef<DataGrid | null>(null);

  return (
    <div className="container-dev">
      <AppLayoutTop title="Транспорт">
        <ClaimsProvider claimsBlock={['CanCreateTransport']}>
          <Button
            width={120}
            text="Создать"
            type="default"
            onClick={() => {
              setOpenId(null);
              setVisible(true);
            }}
          />
        </ClaimsProvider>
      </AppLayoutTop>

      <AddEditModal
        visible={visible}
        changeVisible={(show) => {
          if (!show) setOpenId(null);
          setVisible(show);
        }}
        id={openId}
        refresh={() => refGrid.current?.instance.refresh()}
      />

      <DeleteModal
        visible={visibleDelete}
        changeVisible={(show) => setVisibleDelete(show)}
        id={openIdDelete}
        refresh={() => refGrid.current?.instance.refresh()}
      />

      <AppCard>
        <DataGrid
          dataSource={transportDataStore}
          showBorders={false}
          loadPanel={{
            enabled: true,
            text: 'Загрузка',
          }}
          ref={refGrid}
          remoteOperations={true}
          onRowUpdating={(e) => (e.newData = { ...e.oldData, ...e.newData })}
          onInitNewRow={(e) => (e.data = { name: '' /* isDeleted: false */ })}
        >
          <StateStoring enabled={true} type="localStorage" storageKey="transportTable" />
          <FilterPanel visible={true} />
          <HeaderFilter visible />
          <FilterRow visible={true} />
          <Column dataField="contractor" caption="Контрагент" />
          <Column dataField="transportType" caption="Тип" sortOrder="asc">
            <Lookup dataSource={typeTransport} valueExpr="id" displayExpr="name" />
          </Column>
          <Column dataField="number" caption="Гос. номер" />
          <Column dataField="fullName" caption="Полное наименование" />
          <Column dataField="vinCode" caption="VIN код" />
          <Column dataField="weight" caption="Вес" />
          <Column dataField="quantity" caption="Объём / Метраж" />
          <Column
            dataField=""
            caption=""
            width={150}
            cellRender={(data) => (
              <ClaimsProvider claimsBlock={['CanEditTransport']}>
                <div>
                  <Button
                    icon="edit"
                    type="default"
                    stylingMode="text"
                    onClick={() => {
                      setOpenId(data.key);
                      setVisible(true);
                    }}
                  />
                  <Button
                    icon="trash"
                    type="default"
                    stylingMode="text"
                    onClick={() => {
                      setOpenIdDelete(data.key);
                      setVisibleDelete(true);
                    }}
                  />
                </div>
              </ClaimsProvider>
            )}
          />

          <Paging defaultPageSize={15} />
          <Pager showPageSizeSelector={true} allowedPageSizes={[15, 30, 50, 100]} />
        </DataGrid>
      </AppCard>
    </div>
  );
};

export default TransportPage;
